import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonos } from '../data/offer';
import { Reveal } from './ui/Reveal';
export function BonosSection() {
  return <section aria-labelledby="bonos-title" className="border-b border-line bg-surface/40" data-id="element-19" data-mp="186qs6crh01ln">
      <div className="mx-auto max-w-content px-5 py-16 sm:px-8 lg:py-24" style={{
      paddingTop: "25px",
      paddingBottom: "25px"
    }} data-id="element-20" data-mp="13btbcjny8ny7">
        <div className="mx-auto max-w-2xl text-center" data-id="element-21" data-mp="tg9jq9gf4bf9">
          <h2 id="bonos-title" className="text-2xl font-black leading-tight tracking-tight text-ivory sm:text-3xl lg:text-4xl" style={{
          fontSize: "14px"
        }} data-id="element-22" data-mp="tdnc69tj1vx1">
            6 BONOS ESTRATÉGICOS
          </h2>
          <p className="mt-3 text-base font-black uppercase tracking-wide text-accent sm:text-lg" style={{
          fontSize: "10px",
          fontWeight: "500"
        }} data-id="element-23" data-mp="ffysh5b74utk">
            Siempre incluidos
          </p>
          
        </div>

        <ul className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-24" data-mp="29vb3adachvvu">
          {bonos.map((bono, i) => <Reveal key={bono.index} delay={i * 0.03} className="h-full" data-id="element-25" data-mp="qumrf03g90qg" data-mpi={i}>
              <li className="flex h-full flex-col rounded-2xl border border-line bg-surface px-5 pb-4 pt-3" data-id="element-26" data-mp="vv0r9uuwd4de">
                <div className="flex items-baseline justify-between" style={{
              alignItems: "center",
              justifyContent: "flex-start"
            }} data-id="element-27" data-mp="hvhqxo8buxbn">
                  <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-[0.18em] text-accent" style={{
                fontWeight: "600"
              }} data-id="element-28" data-mp="1ajnfyn6ez8ha">
                    <GiftIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-29" data-mp="10tlrvve29q2d" />
                    {bono.label}
                  </span>
                  
                </div>
                <h3 className="mt-4 text-lg font-bold tracking-tight text-ivory" style={{
              fontSize: "12px",
              fontWeight: "600"
            }} data-id="element-30" data-mp="15qud64uiaa7u">{bono.title}</h3>
                <p className="mt-2 text-[15px] leading-relaxed text-muted" style={{
              fontSize: "12px"
            }} data-id="element-31" data-mp="1yaj3h83u7hiq">{bono.description}</p>
                <div className="mt-auto flex items-center gap-3 pt-6" style={{
              paddingTop: "5px"
            }} data-id="element-32" data-mp="23652a992nhqd">
                  <span className="text-sm text-muted line-through" data-id="element-33" data-mp="1y5r3lhtd1k50">{bono.value}</span>
                  <span className="rounded-md bg-success/15 px-2 py-1 text-xs font-black uppercase tracking-wide text-success" data-id="element-34" data-mp="1t8h4tbk2zw4i">
                    Gratis
                  </span>
                </div>
              </li>
            </Reveal>)}
        </ul>

        <div className="mt-10 rounded-2xl border border-line bg-surfaceAlt p-5 text-center" data-id="element-35" data-mp="1kdavi2llqvx8">
          <p className="text-sm font-semibold uppercase tracking-wide text-muted" style={{
          fontSize: "12px",
          fontWeight: "400",
          color: "#FFFFFF"
        }} data-id="element-36" data-mp="1fe6mbbyogy6w">
            Valor total bonos
          </p>
          <p className="mt-3 text-2xl font-black tracking-tight text-ivory sm:text-3xl" data-id="element-37" data-mp="11grtdx97u8a6">
            <span className="text-muted line-through" style={{
            fontSize: "14px",
            fontWeight: "500",
            textAlign: "left"
          }} data-id="element-38" data-mp="3d3va33i4aszc">$53.000</span>{' '}
            <span className="text-success" style={{
            fontSize: "16px",
            fontWeight: "500",
            textAlign: "left"
          }} data-id="element-39" data-mp="3h7b6pzu6stc1">→ GRATIS con tu MegaPack</span>
          </p>
        </div>
      </div>
    </section>;
}